export default [
  'บริษัท เอ็มซีสยามโลจีสติคส์ จำกัด',
  'บริษัท ผลิตภัณฑ์และวัสดุก่อสร้าง จำกัด',
]
